import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as adminActionCreator from '../../actions/admin';
import { Modal, Button } from 'react-bootstrap';

class PatientChartClosureRequestedDataModal extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {};
    }

    showPHS = () => {
        this.props.adminActions.getPHSPdf( this.props.patient, ( hasError ) => {
            if (!hasError) {
                window.open(this.props.phsPdfUrl, '_blank').focus();
            }
        });
    };

    showRPMSummary = () => {
        this.props.adminActions.getRPMSummaryPdf( this.props.patient, ( hasError ) => {
            if (!hasError) {
                window.open(this.props.rpmSummaryPdfUrl, '_blank').focus();
            }
        });
    };

    showConfidentialNotes = () => {
        this.props.adminActions.getConfidentialNotesPdf( this.props.patient, ( hasError ) => {
            if (!hasError) {
                window.open(this.props.confidentialNotesPdfUrl, '_blank').focus();
            }
        });
    };

    showCCDA = () => {
        this.props.adminActions.getCCDAPdf( this.props.patient )
            .then(() => {
                window.open(this.props.ccdaPdfUrl, '_blank').focus();
            })
            .catch(() => false);
    };

    showMedSummary = () => {
        this.props.adminActions.getMedSummaryPdf( this.props.patient )
            .then(() => {
                window.open(this.props.medSummaryPdfUrl, '_blank').focus();
            })
            .catch(() => false);
    };

    showHealthSummary = () => {
        this.props.adminActions.getHealthSummaryPdf( this.props.patient )
            .then(() => {
                window.open(this.props.healthSummaryPdfUrl, '_blank').focus();
            })
            .catch(() => false);
    };

    showQualitySummary = () => {
        this.props.adminActions.getQualitySummaryPdf( this.props.patient )
            .then(() => {
                window.open(this.props.qualitySummaryPdfUrl, '_blank').focus();
            })
            .catch(() => false);
    };

    componentDidUpdate(prevProps) {
        const patient = this.props.patient;
        if (!prevProps.patient && patient) {
            this.props.adminActions.getCCDAAvailability(patient);
            this.props.adminActions.getMedSummaryAvailability(patient);
            this.props.adminActions.getConfidentialNotesAvailability(patient);
            this.props.adminActions.getRPMSummaryAvailability(patient);
            this.props.adminActions.getHealthSummaryAvailability(patient);
            this.props.adminActions.getQualitySummaryAvailability(patient);
        } else if (prevProps.patient !== patient && patient) {
            this.props.adminActions.getCCDAAvailability(patient);
            this.props.adminActions.getMedSummaryAvailability(patient);
            this.props.adminActions.getConfidentialNotesAvailability(patient);
            this.props.adminActions.getRPMSummaryAvailability(patient);
            this.props.adminActions.getHealthSummaryAvailability(patient);
            this.props.adminActions.getQualitySummaryAvailability(patient);
        }
    }

    render() {
        const { ccdaAvailable, medSummaryAvailable, rpmSummaryAvailable, healthSummaryAvailable, qualitySummaryAvailable, confidentialNotesAvailable , loadNoteNeeded} = this.props;
        return(
            <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Chart Closure Requested</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-align-center">
                        <Button bsStyle="success"
                                id="openPhsButton"
                                onClick={ this.showPHS }>
                            PHS
                        </Button>
                        { loadNoteNeeded && !confidentialNotesAvailable ?
                            <div>Confidential Notes Summary is unavailable for the patient.</div>
                            :
                            <Button bsStyle="success"
                                    id="showConfidentialNotes"
                                    style={{ marginLeft: "10px" }}
                                    onClick={ this.showConfidentialNotes }>
                                Confidential Notes Summary
                            </Button>
                        }
                        { !rpmSummaryAvailable ?
                            <div>RPM Summary is unavailable for the patient.</div>
                            :
                            <Button bsStyle="success"
                                    id="showRPMSummary"
                                    style={{ marginLeft: "10px" }}
                                    onClick={ this.showRPMSummary }>
                                RPM Summary
                            </Button>
                        }
                        { !ccdaAvailable ?
                            <div>CCDA is unavailable for the patient.</div>
                            :
                            <Button bsStyle="success"
                                    id="openCCDAButton"
                                    style={{ marginLeft: "10px" }}
                                    onClick={ this.showCCDA }>
                                CCDA
                            </Button>
                        }
                        { !medSummaryAvailable ?
                            <div>Med Summary is unavailable for the patient.</div>
                            :
                            <Button bsStyle="success"
                                    id="openMedSummaryButton"
                                    style={{ marginLeft: "10px" }}
                                    onClick={ this.showMedSummary }>
                                Med Summary
                            </Button>
                        }
                        { !healthSummaryAvailable ?
                            <div>Health Summary is unavailable for the patient.</div>
                            :
                            <Button bsStyle="success"
                                    id="openHealthSummaryButton"
                                    style={{ marginLeft: "10px" }}
                                    onClick={ this.showHealthSummary }>
                                Health Summary
                            </Button>
                        }
                        { !qualitySummaryAvailable ?
                            <div>Quality Summary is unavailable for the patient.</div>
                            :
                            <Button bsStyle="success"
                                    id="openQualitySummaryButton"
                                    style={{ marginLeft: "10px" }}
                                    onClick={ this.showQualitySummary }>
                                Quality Summary
                            </Button>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.props.onHide}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    ccdaAvailable: state.levelTwoDashboard.ccdaAvailable,
    confidentialNotesAvailable: state.levelTwoDashboard.confidentialNotesAvailable,
    rpmSummaryAvailable: state.levelTwoDashboard.rpmSummaryAvailable,
    medSummaryAvailable: state.levelTwoDashboard.medSummaryAvailable,
    healthSummaryAvailable: state.levelTwoDashboard.healthSummaryAvailable,
    qualitySummaryAvailable: state.levelTwoDashboard.qualitySummaryAvailable,
    ccdaPdfUrl: state.levelTwoDashboard.ccdaPdfUrl,
    phsPdfUrl: state.levelTwoDashboard.phsPdfUrl,
    rpmSummaryPdfUrl: state.levelTwoDashboard.rpmSummaryPdfUrl,
    confidentialNotesPdfUrl: state.levelTwoDashboard.confidentialNotesPdfUrl,
    medSummaryPdfUrl: state.levelTwoDashboard.medSummaryPdfUrl,
    healthSummaryPdfUrl: state.levelTwoDashboard.healthSummaryPdfUrl,
    qualitySummaryPdfUrl: state.levelTwoDashboard.qualitySummaryPdfUrl,
});

const mapDispatchToProps = ( dispatch ) => ({
    adminActions: bindActionCreators( adminActionCreator, dispatch ),
});

export default connect( mapStateToProps, mapDispatchToProps )( PatientChartClosureRequestedDataModal );
